import React, { useEffect, useState } from 'react'
import { Table, List, Avatar, Button, Skeleton, Steps, Space, Tabs, Form, Breadcrumb, Tag, Radio, Image, Card, Popconfirm } from 'antd';
import MainLayouts from '../../layouts/MainLayouts';
import _Api from '../../services/Api/_Api';
import { Date_, _Button, _Input, _Number, _Select } from '../../services/Forms/Forms';
import { Col, Nav, Row } from 'react-bootstrap';
import _Nav from '../../layouts/_Nav';
import { _Row } from '../../services/Forms/LayoutBootstrap';
import { BackwardFilled, DoubleLeftOutlined, DoubleRightOutlined, DownloadOutlined } from '@ant-design/icons';
import { _Toastr, msg } from '../../services/Toastr/Notify/_Toastr';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { baseURL_R_file } from '../../services/BaseUrl';
import { SocketIO, formatNumber } from '../../services/Text/GlobalText';
import RenderSteps from './Steps/Steps';
import UploadBerkas from './Upload/UploadBerkas';
import { dataUser } from '../../services/Cache/Auth';
import CountDownX from '../../services/Forms/CountDown';
import { acakText } from '../../services/Crypto';
import getQuery from '../../services/Forms/LyBootstrapt';
import StepStatusBayar from './Steps/StepStatusBayar';
var randomstring = require("randomstring");



function OrderKonselingMobile() {


    // const [playSound] = useSound("/sound/audio.wav");



    const [steps, setsteps] = useState(0)
    const [bankPilih, setbankPilih] = useState("")
    const [norec, setnorec] = useState("")
    const [frmk] = Form.useForm()
    const [frmh] = Form.useForm()
    const [listBuktiT, setlistBuktiT] = useState([])
    const [isiForm, setisiForm] = useState({})
    const [tarif, settarif] = useState(35000)
    const [verifikasi, setverifikasi] = useState("")
    const [udahUploadBukti, setudahUploadBukti] = useState(false)
    const [batasbayar, setbatasbayar] = useState("");
    const [idKonseling, setidKonseling] = useState("");
    const [dataOrder, setdataOrder] = useState({});

    const history = useHistory();


    const simpanArsip = () => {
        const konst = getQuery('konsId')
        const pembeli_id = getQuery('pembeli_id')

        const dataobj = frmk.getFieldsValue();
        const obj = {
            id: konst,
            tglkonseling: moment(dataobj.tglkonseling).format('YYYY-MM-DD H:m:s'),
            kodebank: dataobj.bank,
            pembeli_id : pembeli_id
        }
        _Api.post("/simpan-konseling-rev", obj).then(res => {
            if (res.data.sts == "1") {
                var dt = res.data.data
                setdataOrder(dt)
                setidKonseling(res.data.data.id)

                setbatasbayar(dt.batasbayar)
                msg.success("Suksess .!")
                history.push({
                    pathname: '/OrderKonselingMobile',
                    search: '?konsId=' + dt.id + "&xtemp=" + dt.kodeorderkonseling
                })
                setsteps(1)
            }
            else
                msg.error("Gagal simpan data .! .!")
        })
    }


    useEffect(() => {
        // loadData()
        const konst = getQuery('konsId')

        frmh.setFieldsValue(dataUser.login)
        console.log(dataUser.login)

        // setrandom(randomstring.generate(10) + moment().format('YYYYMMDDHHmmss'))
        if (konst != "" && konst != null) {
            _Api.get("/get-konseling-single?konsId=" + konst).then(res => {
                var e = res.data.konseling
                setdataOrder(e)
                var bukti = res.data.buktitf;
                setudahUploadBukti(bukti.length > 0)
                bukti.map((r, i) => {
                    bukti[i].url = baseURL_R_file + r.url
                })
                setlistBuktiT(res.data.buktitf)
                setsteps(e.step)
                var g = listBank.filter(f => f.value == e.bank)
                setnorec(g[0].norec)
                settarif(e.tagihan)
                setbankPilih(e.bank)
                frmk.setFieldsValue({ "bank": e.bank, tglkonseling: moment(e.tgl) })
                setbatasbayar(e.batasbayar)
                setverifikasi(e.status)
                setidKonseling(konst)
            })
        }
    }, [])

    // useEffect(() => {
    //     SocketIO.on("refreshArsip", (data) => {
    //         // setverifikasi(true)
    //         // toggle()
    //     });
    // }, []);





    const lanjut = () => {

        const tgl = frmk.getFieldValue("tglkonseling")
        const bank = frmk.getFieldValue("bank")
        const metodebayar = frmk.getFieldValue("metodebayar")
        switch (steps) {
            case 0:
                if (tgl == undefined || bank == undefined || metodebayar == undefined) {
                    msg.error("Silahkan pilih tanggal , cara Bayar dan Bank tujuan transfer .!")
                    return
                }
                if (metodebayar == "Tunai") {
                    setsteps(2)

                } else {
                    simpanArsip()
                }
                break;
            case 1:
                if (udahUploadBukti == false) {
                    msg.error("Silahkan upload bukti transfer .!")
                    return
                }
                setsteps(steps + 1)

                break
            case 2:

                break
        }

    }



    const mundur = () => {
        setsteps(steps - 1)
    }

    const { TabPane } = Tabs;

    const listBank = [
        { kode: "NTB.png", label: "Bank NTB", value: "NTB", norec: "177384-554-3246-44" },
        { kode: "BCA.png", label: "Bank BCA", value: "BCA", norec: "177384-345-3246-55" },
        { kode: "BNI.png", label: "Bank BNI", value: "BNI", norec: "177384-554-4563-86" },
        { kode: "BSI.png", label: "Bank BSI", value: "BSI", norec: "177384-554-4385-26" },
    ]

    const iniPilihBank = (e) => {
        var pb = e.target.value

        var g = listBank.filter(e => e.value == pb)
        // frmk.setFieldValue('norec', g[0].norec)
        // 
        setnorec(g[0].norec)
        setbankPilih(pb)
    }


    const kembaliKeMenuKonseling = () => {
        if(dataUser.user.role == "adm") 
            history.push("RiwayatKonselingGizi")
        else
            history.push("RiwayatKonseling")
    }
    // const verifikasiBuktiTransfer = () => {
    //     const konst = getQuery('konsId')

    //     if (konst != "" && konst != null) {
    //         _Api.get("/verifikasi-bukti-transfer?konselingId=" + konst).then(res => {
    //             var data = res.data
    //             if (data.sts == "1") {
    //                 SocketIO.emit('konfirmasipembayaran', data.kons);
    //                 history.push("/RiwayatKonselingGizi")
    //                 // RiwayatKonselingGizi
    //             }
    //         })
    //     } else {
    //         msg.error("Konseling tidak ditemukan !")
    //     }

    // }
    const RenderStepUpload = () => {
        return (
            <Form form={frmh} labelCol={{ span: "8" }} wrapperCol={{ span: "10" }}>
                <_Input label="Nama" required disabled name="namapembeli" />
                <_Input label="No. HP (WA)" required disabled name="nohp" />
                <_Input label="Alamat" multiline required name="alamatlengkap" disabled />
                <br />
                <center>
                    <label> Total Tagihan : </label>
                    <h1> Rp.  {formatNumber(tarif)} </h1>
                    <label> Bank Tujuan : </label>
                    <br />
                    <Image width={200} style={{ textAlign: "center" }} preview={false} src={baseURL_R_file + "images/bank/" + bankPilih + ".png"} />
                    <br />
                    <br />
                    <_Input label="No. Rekening" value={norec} disabled required />
                    {
                        !udahUploadBukti &&
                        <div>
                            <label> Batas Waktu : </label>
                            {
                                batasbayar != "" &&
                                <CountDownX tgl={batasbayar} />
                            }
                        </div>
                    }
                    <div>  Bukti Transfer </div>
                    <UploadBerkas buktitf={listBuktiT} konseling_id={idKonseling} dataOrder={dataOrder} status={verifikasi} setudahUploadBuktiTf={setudahUploadBukti} />
                </center>
            </Form>
        )
    }

    // var tarif = 35000;
    return (
        <div className='p-3'>
            {/* <Breadcrumb style={{ margin: '16px 0' }}>
                <Item>{isiForm && isiForm.id}</Item>
                <Item>{isiForm && isiForm.jenis}</Item>
                <Item>{jenispk}</Item>
            </Breadcrumb> */}

            <br />
            <RenderSteps steps={steps} />
            <br />
            <Form form={frmk} initialValues={{ "metodebayar": "Transfer" }}>
                <Tabs activeKey={`${steps + 1}`} tabBarStyle={{ height: "1px" }} tabPosition="bottom">
                    <TabPane key="1">
                        <Row>
                            <Card className='p-3'>
                                <h2> Rencana Konseling </h2>
                                <label><b> Tanggal </b> </label>
                                <Date_ sm={4} name="tglkonseling" disabled={udahUploadBukti} />
                                <label> Tarif Konseling : </label>
                                <h1> Rp. {formatNumber(tarif)} </h1>
                                <Row>
                                    <Col sm={12} >
                                        <label> Cara Bayar : </label>
                                        <br />
                                        <Form.Item name="metodebayar" >
                                            <Radio.Group >
                                                <Radio value="Tunai" key={"tunai"} disabled>Tunai</Radio>
                                                <Radio value="Transfer" key="transfer">Transfer</Radio>
                                            </Radio.Group>

                                        </Form.Item>
                                        <br />

                                        <label style={{ marginBottom: "10px" }}> Akan Ditransfer Ke : </label>


                                        <Form.Item name="bank">
                                            <Radio.Group >
                                                <Space direction="vertical">
                                                    {
                                                        listBank.map(e => {
                                                            return (
                                                                <Radio disabled={udahUploadBukti} value={e.value} onChange={iniPilihBank}
                                                                    className='b hover rounded px-3'>
                                                                    {e.label}
                                                                    <br />
                                                                    <Image width={200} preview={false} src={baseURL_R_file + "images/bank/" + e.kode} />
                                                                </Radio>
                                                            )
                                                        })
                                                    }
                                                </Space>
                                            </Radio.Group>
                                        </Form.Item>

                                    </Col>
                                </Row>
                            </Card>
                        </Row>

                    </TabPane>
                    <TabPane key="2">
                        {RenderStepUpload()}
                    </TabPane>
                    <TabPane key="3">
                        <StepStatusBayar RenderStepUpload={{ RenderStepUpload }} dataOrder={dataOrder} verifikasi={verifikasi} />
                        {RenderStepUpload()}
                        {/* {verifikasi == "MK" && dataUser.user.role == "adm" &&
                            <center>
                                <Popconfirm
                                    title="Anda sudah melakukan pengecekan pada bukti transfer di atas ? ."
                                    okText="Ya, Sudah"
                                    onConfirm={verifikasiBuktiTransfer}
                                    cancelText="Belum">
                                    <_Button label="Konfirmasi" sm={3} block size="large" color="green" className="mb-2" />
                                </Popconfirm>
                                <Popconfirm
                                    title="Anda yakin akan membatalkan / menolak konseling ini ? ."
                                    okText="Ya, Tolak"
                                    cancelText="Tidak">
                                    <_Button label="Tolak" sm={3} block size="large" color="red" className="mb-2" />
                                </Popconfirm>

                            </center>
                        } */}

                    </TabPane>
                </Tabs>
            </Form>
            <div style={{ display: "flex", marginTop: "20px" }}>
                <_Button label="Mundur" icon={<DoubleLeftOutlined />} disabled={steps == 0} sm={1} block onClick={mundur} /> &nbsp;
                {steps == 2 ?
                    // <_Button label="Kembali" icon={<BackwardFilled />} onClick={kembaliKeMenuKonseling} sm={3} block /> :
                   <div></div>:
                    <_Button label="Lanjut" icon={<DoubleRightOutlined />} disabled={steps == 2} sm={1} block onClick={lanjut} />
                }
            </div>
        </div >
    )
}

export default OrderKonselingMobile
